module.exports = __webpack_public_path__ + "img/body-2.2c194ae1.png";